import styled from 'styled-components';

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export default { Contents };
